import React from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import HoneycombImg from '../../images/honeycomb.png';

const CorrectAreaLoading = (props) => {
  const LoadingArea = css`
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #ffffff6b;
      backdrop-filter: blur(3px);
      z-index: 999;
      overflow: hidden;
      color: #555555;
      transition: 1s ease-in-out;
      padding: 100vh;
      opacity: ${props.isLoading ? 0 : 1};

    @keyframes rotate-anime {
      0%  {transform: rotate(0);}
      100%  {transform: rotate(360deg);}
    }

    img {
      animation: rotate-anime 1s ease infinite;
      margin-top: 160px;
      height: 300px;
      width: auto;
    }
    div {
      text-align: center;
    }
  `;

  return (
    <>

      <div css={LoadingArea}>

        <img src={HoneycombImg} alt="" />
        <div>
          🧮: 計算しています...
        </div>
      </div>

    </>
  )
}

export default CorrectAreaLoading
